import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { centralizedHost } from "~/Utils";

export interface DocumentDetailsResponse {
  id: number;

  // Titles
  title: string;
  title_malay: string;
  title_mandarin: string;

  // Outlet Details
  outlet: string;
  slug: string;
  store_time: string;
  location_code: string;
  airport: string;
  source: string;

  // Select Fields
  brand: any;
  data_classification: any;
  shop_category: number;
  sub_category: string[];
  tag: string[];
  type: string[];
  zone: number;

  // Images
  image: string;
  web_image: string;
  mobile_image: string;
  banner_image: string;

  // Image Descriptions
  image_description: string;
  image_description_malay: string;
  image_description_mandarin: string;

  // Booleans
  is_active: boolean;
  is_temporarily_closed: boolean;
  gender_separated: boolean;
  braille_signage: boolean;
  wheel_chair: boolean;
  published: boolean;

  // SEO
  seo_title: string;
  seo_description: string;

  closure_reason: string;

  // Dates
  start_date: string;
  end_state: string;

  // Created / Updated By
  created_by: string;
  last_modified_by: string;

  // Coordinates
  latitude: number;
  longitude: number;

  // Contact
  phone: number;
  email: string;

  // Additional
  regulatory_compliance: string;
  search_weight: number;
  analytics_id: number;
  technical_id: number;
  tenant_id: number;
  version: number;
  type_poi: string;
  redirect_url_id: number;

  // Metadata
  created: string;
  updated: string;
  centralize_zone: any;
  field_project_airport: any;
  centralize_zone_level: any;
}

// edit api call
const fetchPageContentDetails = async (id: string): Promise<any> => {
  if (!id) {
    return null;
  }
  const response: any = await axios.get(`${centralizedHost}/api/shop-store/${id}`);

  return response?.data[0];
};

const usePageDocumentDetails = (
  id: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>(
    {
      queryKey: ["pageContenDetails", id],
      enabled: false,
      queryFn: () => {
        return fetchPageContentDetails(id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { usePageDocumentDetails };
